module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/YG4gEm/tc-custom/9783968655499.jpg?1703042121621",
      "alt": "This image is the cover for the book Über den Umgang mit Menschen, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Über den Umgang mit Menschen, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Über den Umgang mit Menschen ist das bekannteste Werk des deutschen Schriftstellers Adolph Freiherr Knigge (1752–1796). Es erschien erstmals im Jahre 1788. Das Buch beschäftigt sich mit „guten Umgangsformen“, was hier nicht mit der Etikette gleichzusetzen ist. Es wurde vielfach übersetzt. Im Gegensatz zur heutigen landläufigen Meinung handelt es sich bei dem Buch keineswegs um ein Benimmbuch mit Ratschlägen zu Fragen wie, welche Gabel mit welchem Messer zu welchem Essen verwendet werden darf. Das Buch ist vielmehr eine einsichtsreiche und eine von den Idealen der Aufklärung geprägte Sammlung von „Umgangsregeln“.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Adolph Freiherr von Knigge\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Adolph Franz Friedrich Ludwig Freiherr Knigge (* 16. Oktober 1752 in Bredenbeck bei Hannover; † 6. Mai 1796 in Bremen) war ein deutscher Schriftsteller und Aufklärer. Von 1780 bis 1784 war er ein führendes Mitglied des Illuminatenordens. Bekannt wurde er vor allem durch seine Schrift Über den Umgang mit Menschen. Sein Name steht heute stellvertretend, aber irrtümlich, für Benimmratgeber, die mit Knigges eher soziologisch ausgerichtetem Werk im Sinne der Aufklärung nichts gemeinsam haben.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0